module.exports = __webpack_public_path__ + "static/img/szafa_dso_36.eae9baf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_dso_36.svg
// module id = wlZf
// module chunks = 1